module.exports = __webpack_public_path__ + "static/TrueUp-Team-Photo-395e1281e3397857a6cd59b2981b07d2.jpg";